import styled from 'styled-components';
import { darken } from 'polished';
import colors from '~/styles/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${props => (props.flex ? props.flex : 1)};
`;
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-weight: bold;
  color: white;
  background: ${colors.primary};
  border-bottom: 0.5rem solid ${darken(0.1, colors.primary)};
  padding: 1.5rem;
`;
export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background: white;
  padding: 1.5rem;
`;
